import React from 'react';
import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import { statusColors } from 'src/components/utils/consts';
import { abbreviate } from 'src/components/utils/utils';
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons";

function UserImage({ agent }) {

    const { t } = useTranslation();

    const loggedOutLabel = t('loggedout');
    const registeredLabel = t('registered');
    const pausedLabel = t('paused');
    const pauseExceededLabel = t('pausetimeexceeded');
    const wrapupLabel = t('wrapup');
    const unregisteredLabel = t('unregistered');

    const title = useMemo((data) => {
        let ret = loggedOutLabel;
        if (agent) {
            let diff = 0;
            let acdStatusChanged = new Date();
            acdStatusChanged.setSeconds(acdStatusChanged.getSeconds() - agent.timeDiffAcdStatus);
            diff = Math.floor((Date.now() - acdStatusChanged) / 1000);

            switch (agent.strAcdStatus) {
                case "Free":
                    ret = registeredLabel + (agent.timeDiffStr ? ` - ${agent.timeDiffStr}` : '');
                    break;
                case "Paused":
                    ret = pausedLabel;
                    if (agent.pauseType)
                        ret += ` - ${agent.pauseType}`;
                    if (agent.timeDiffStr)
                        ret += ` - ${agent.timeDiffStr}`;
                    if (agent.pauseAlarm)
                        ret += ` - ${pauseExceededLabel}`;
                    break;
                case "Wrapup":
                    ret = wrapupLabel;
                    break;
                case "Unregistered":
                    ret = unregisteredLabel;
                    break;
                default:
                    ret = loggedOutLabel;
                    break;
            }
        }

        return ret;
    }, [agent, loggedOutLabel, registeredLabel, pausedLabel, wrapupLabel, unregisteredLabel, pauseExceededLabel]);

    return (
        <div className="symbol symbol-50px me-3" title={title}>
            {
                !agent.photo &&
                <div key={`letter_${agent.pin}`} className='user-img text-primary bg-light-primary'>{abbreviate(agent.fullName || agent.name)}</div>
            }
            {
                agent.photo &&
                <img key={`img_${agent.pin}`} src={`//${agent.photo}`} alt="agent" />
            }
            {
                !agent.pauseAlarm &&
                <div className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-3 border-body h-20px w-20px bg-${statusColors[agent?.strAcdStatus?.toLowerCase()]}`}></div>
            }
            {
                agent.pauseAlarm &&
                <div className="position-absolute translate-middle bottom-0 start-100 mb-6"><FontAwesomeIcon className="px-1 text-danger" size="lg" icon={faTriangleExclamation} /></div>
            }
        </div>
    );
}

export default UserImage;